import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=41f6b210&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f6b210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41f6b210')) {
      api.createRecord('41f6b210', component.options)
    } else {
      api.reload('41f6b210', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=41f6b210&scoped=true&", function () {
      api.rerender('41f6b210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYuE96YCDUxt/JS/comp/Accordion.vue"
export default component.exports